function object(raw) {
  if (typeof raw === 'string') {
    try {
      return object(JSON.parse(raw));
    } catch {
      return undefined;
    }
  }
  return raw !== null && typeof raw === 'object' && !Array.isArray(raw) ? raw : undefined;
}
const text = function (raw, max) {
  if (max === void 0) {
    max = 512;
  }
  return typeof raw === 'string' && raw.length > 0 ? raw.slice(0, max) : undefined;
};
const count = raw => typeof raw === 'number' && Number.isSafeInteger(raw) && raw >= 0 ? raw : undefined;

/** A product image is trusted only from Shopify's own CDN; anything else renders the same placeholder as no image. */
export function shopifyCdnImageUrl(raw) {
  if (typeof raw !== 'string') {
    return undefined;
  }
  try {
    const url = new URL(raw);
    return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && !url.username && !url.password && !url.port ? url.href : undefined;
  } catch {
    return undefined;
  }
}
export function readConnectorResultCard(metadata) {
  var _object, _object2;
  const card = object((_object = object(metadata)) == null ? void 0 : _object.connectorResultCard);
  if ((card == null ? void 0 : card.provider) !== 'shopify' || !Array.isArray(card.items)) {
    return null;
  }
  if (((_object2 = object(card.source)) == null ? void 0 : _object2.status) === 'unavailable') {
    return null;
  }
  const items = [];
  for (const raw of card.items.slice(0, 10)) {
    const row = object(raw);
    const id = text(row == null ? void 0 : row.id, 256);
    const title = text(row == null ? void 0 : row.title);
    if (!id || !title || items.some(item => item.id === id)) {
      continue;
    }
    const imageState = row == null ? void 0 : row.imageState;
    const status = row == null ? void 0 : row.status;
    const price = object(row == null ? void 0 : row.price);
    const item = {
      id,
      title,
      imageState: imageState === 'ready' || imageState === 'missing' || imageState === 'pending' || imageState === 'failed' ? imageState : 'unknown'
    };
    if (status === 'ACTIVE' || status === 'DRAFT' || status === 'ARCHIVED') {
      item.status = status;
    }
    item.description = text(row == null ? void 0 : row.description, 300);
    item.imageAlt = text(row == null ? void 0 : row.imageAlt);
    if (item.imageState === 'ready') {
      item.imageUrl = shopifyCdnImageUrl(row == null ? void 0 : row.imageUrl);
    }
    if (typeof (price == null ? void 0 : price.amount) === 'string' && /^\d+(\.\d+)?$/.test(price.amount) && typeof price.currencyCode === 'string' && /^[A-Z]{3}$/.test(price.currencyCode)) {
      item.price = {
        amount: price.amount,
        currencyCode: price.currencyCode
      };
      if (typeof price.maxAmount === 'string' && /^\d+(\.\d+)?$/.test(price.maxAmount)) {
        item.price.maxAmount = price.maxAmount;
      }
    }
    item.variantsCount = count(row == null ? void 0 : row.variantsCount);
    if (typeof (row == null ? void 0 : row.inventory) === 'number' && Number.isSafeInteger(row.inventory)) {
      // An oversold product reports negative stock; the owner has none left to sell.
      item.inventory = Math.max(0, row.inventory);
    }
    items.push(item);
  }
  if (!items.length) {
    return null;
  }
  const result = {
    provider: 'shopify',
    items
  };
  const source = object(card.source);
  if ((source == null ? void 0 : source.provider) === 'shopify' && typeof source.storeDomain === 'string' && /^[a-z0-9][a-z0-9-]{0,59}\.myshopify\.com$/.test(source.storeDomain) && (source.status === 'complete' || source.status === 'partial')) {
    result.source = {
      provider: 'shopify',
      storeDomain: source.storeDomain,
      status: source.status,
      ...(typeof source.readAt === 'string' && Number.isFinite(Date.parse(source.readAt)) ? {
        readAt: source.readAt
      } : {}),
      storeName: text(source.storeName),
      coverage: text(source.coverage, 1024)
    };
  }
  return result;
}